import { render, staticRenderFns } from "./DocShareType.vue?vue&type=template&id=0f76a8d3&scoped=true&"
import script from "./DocShareType.vue?vue&type=script&lang=js&"
export * from "./DocShareType.vue?vue&type=script&lang=js&"
import style0 from "./DocShareType.vue?vue&type=style&index=0&id=0f76a8d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76a8d3",
  null
  
)

export default component.exports